<ng-container *ngIf="data.hasAccess && !data.accessDenied">
   <div class="modal-wrapper">
      <div class="source-info-container">
         <div class="source-info-header">
            <span class="source-info-title">{{ 'report.source_information' | translate }}</span>
            <button class="close-btn" mat-dialog-close aria-label="Close">&#10005;</button>
         </div>
         <table class="source-info-table">
            <thead>
               <tr>
                  <th>{{ ((fromkopinor ? 'app.upload.book_title' : 'app.upload.document_title') | translate) + ': ' }} </th>
                  <th>{{ ((fromkopinor ? 'individual.upload.date_of_publish' : 'individual.upload.date_of_upload') | translate) + ': ' }}</th>
                  <th>{{ ((fromkopinor ? 'metadata.author' : 'report.user_name') | translate) + ': ' }}</th>
                  <th>{{ ((fromkopinor ? 'report.publisher' : 'report.user_institution') | translate) + ': ' }}</th>
                  <th *ngIf="allowExternalDownload && !fromkopinor">{{ 'report.download_file' | translate }}</th>
               </tr>
            </thead>
            <tbody>
               <tr>
                  <td>{{ this.title }}</td>
                  <td>{{ this.creationDate }}</td>
                  <td>{{ this.user }}</td>
                  <td>{{ this.institution || '//' }}</td>
                  <td *ngIf="allowExternalDownload">
                     <a class="download-link" (click)="downloadExternalDocument()">
                        <img src="../../../../../../assets/report_v2/download.svg" alt="Download" class="download-icon">
                        {{ 'report.download' | translate }}
                     </a>
                  </td>
               </tr>
            </tbody>
         </table>
      </div>

         <div style="width: auto; margin-bottom: 30px;" class="content_wrapper" *ngIf="fromkopinor">
      <div *ngIf="!deletedFromArchive && enablePII" style="margin: auto; padding-top: 30px;" [innerHTML]="processedContent"></div>
       <div class="from-kopinor" *ngIf="fromkopinor"> {{ 'report.from_kopinor' | translate }} </div>
   </div>

      <div class="content_wrapper" *ngIf="!fromkopinor">
         <div *ngIf="!deletedFromArchive && enablePII" class="pii-content" [innerHTML]="processedContent"></div>

         <div *ngIf="!enablePII && !deletedFromArchive" class="pdf-viewer-scrollable">
            <pdf-viewer id="viewer" [src]="pdfSrc" [render-text]="true" [fit-to-page]="true"
               (after-load-complete)="callBackFn($event)" class="pdf-viewer-content"></pdf-viewer>
         </div>
      </div>

      <div class="modal-footer">
         <button class="btn-secondary-md" mat-dialog-close>{{ 'general.close' | translate }}</button>
      </div>
   </div>
   
</ng-container>

<ng-container *ngIf="data.accessDenied">
   <div class="access_denied">
      {{ 'new_entries.access_denied' | translate }}
      <button mat-dialog-close>{{ 'aria-labels.go_back' | translate }}</button>
   </div>
</ng-container>

<ng-container *ngIf="!data.hasAccess && !data.accessDenied">
   <div class="request_access">
      <h3>{{ 'new_entries.request_access_to_document' | translate }}</h3>
      <p>{{ 'new_entries.stored_in_different_institution' | translate }}</p>
      <h5><b>Institution you're requesting access to:</b> {{ data.submissionUserDetails.Institution.name }} </h5>
      <div class="req_input">
         <h4>{{ 'new_entries.request_purpose' | translate }}</h4>
         <input [(ngModel)]="requestPurpose" type="text">
      </div>
      <h6>{{ 'new_entries.specify_purpose_of_request' | translate }}</h6>
      <div class="btns">
         <button mat-dialog-close class="close_btn">{{ 'general.close' | translate }}</button>
         <button class="submit_btn" (click)="submit()">{{ 'new_entries.submit_request' | translate }}</button>
      </div>
   </div>
</ng-container>